import OrderApi from "api/OrderApi";

class WxPay {
  async pay(data) {
    const orderData = await this.createOrder(data)
    if(orderData.code != 20000) return
    return orderData.data
  }
  createOrder(data) {
    data = {
      subject: '河小象',
      ...data,
      pay_type: 'wx_pay',
      app_id: process.env.VUE_APP_MODE === 'production' ? 'wx05d995b24ad77759' : 'wx4ece837666523ebd',
      order_type: 1,
      trade_type: 'JSAPI'
    }
    return OrderApi.createNewOrder(data) 
  }
}

export default new WxPay()